export default defineNuxtRouteMiddleware(async (to) => {
  const runtimeConfig = useRuntimeConfig()
  const restrictedRoutes = {
    iocl: [
      '/finance/app/dashboard',
      '/finance/app/dashboard?tid=GL',
      '/loans'
    ],
  }

  try {
    const partner = runtimeConfig.public.partnerName?.toLowerCase()
    const partnerRestrictedPages = restrictedRoutes[partner] || []
    if (partnerRestrictedPages.includes(to.fullPath)) {
      return navigateTo('/')
    }
  } catch (err) {
    console.error('Error during route restriction check:', err)
  }
})
